<template>
  <v-dialog
    v-model="dialog"
    :disabled="disabled"
    width="750">
    <v-btn
      slot="activator"
      :disabled="disabled"
      :color="values.confirmBtnColor"
      :style="values.btnTextColour"
      @click="$emit('openClick')"><v-icon dark>{{ values.icon }}</v-icon>{{ values.openBtnText }}</v-btn>

    <v-card>
      <v-card-title
        class="headline primary"
        style="color: white !important;"
        primary-title="">
        {{ values.headline }}
      </v-card-title>
      <v-card-text>
        {{ values.text }}
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <span 
          v-if="!loading"
          class="pseudolink"
          @click="dialog = false">{{ 'krita.close' | translate }}</span>
        <v-spacer/>
        <v-btn
          :loading="loading"
          :disabled="loading"
          :color="values.confirmBtnColor"
          :class="values.btnTextColour"
          @click="$emit('confirmClick')"
        >{{ values.confirmBtnText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'ModuleBtn',
    props: ['values','disabled','loading','dialog'],
}
</script>

<style lang="css" scoped>
    .pseudolink {
        color:blue;
        cursor:pointer;
    }
</style>
